import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import {
  SecureLinkAudienceType,
  SecureLinkExpiryType,
  SecureLinkModeType,
  SecureLinkType,
  SecureLinkViaType,
} from '@/types/myVaultTypes';

export type CreateSecureLinkPayloadType = {
  vault_account_id: string;
  rail: string;
  mode: SecureLinkModeType;
  via: SecureLinkViaType;
  audience: SecureLinkAudienceType;
  sent_to: string;
  expiry_code: SecureLinkExpiryType;
  one_time: boolean;
  named_only: boolean;
};

export const createSecureLinkApi = (
  data: CreateSecureLinkPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<SecureLinkType>> => {
  return authApiService.POST('/my-vault/links/create/', data, null, options);
};
